import { Text } from "@chakra-ui/react";
import type { ReactElement, ReactNode } from "react";

/**
 * A single fact about a row, each stating what it is of. Shared by the group
 * price ladder and the operator ranked list so both sections speak one
 * secondary-metadata language.
 */
export function Meta({ children }: { children: ReactNode }): ReactElement {
  return (
    <Text
      className="tabular-nums"
      fontFamily="var(--font-geist-mono)"
      fontSize="12px"
      letterSpacing="0.02em"
      color="var(--color-text-tertiary)"
    >
      {children}
    </Text>
  );
}
